import * as i0 from "@angular/core";
export class GetOwnerDisplayNamePipeModule {
}
GetOwnerDisplayNamePipeModule.ɵfac = function GetOwnerDisplayNamePipeModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GetOwnerDisplayNamePipeModule)(); };
GetOwnerDisplayNamePipeModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GetOwnerDisplayNamePipeModule });
GetOwnerDisplayNamePipeModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
